import { FC, PropsWithChildren } from 'react'
import { Badge } from '@components-v2/atoms/Badge'
import styles from './index.module.scss'

type Props = {
  title: string
  badgeContent?: string
}

export const ProfilePageSection: FC<PropsWithChildren<Props>> = ({ children, title, badgeContent }) => {
  return (
    <div className={styles.container}>
      <div className={styles.head}>
        <div className={styles.title}>{title}</div>
        {badgeContent && (
          <div className={styles.badge}>
            <Badge>{badgeContent}</Badge>
          </div>
        )}
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  )
}
